import React, { useEffect, useLayoutEffect, useState } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { ConfigProvider, Layout } from 'antd';

import './App.css';

import Home from './components/Home';

const { Content, Footer } = Layout;

const App = () => {

  return (
    <HashRouter>
      <ConfigProvider>
        <Layout className="layout" style={{ position: 'relative' }}>

          <Content style={{ position: 'relative' }}>
            <Switch>
              <Route path="/" exact component={Home} />

              <Route path="*" render={() =>
                <React.Fragment>
                  <h1>404 NOT FOUND</h1>
                </React.Fragment>
              } />
            </Switch>
          </Content>
        </Layout>
      </ConfigProvider>
    </HashRouter>
  );
};

export default App;
